module.exports = __webpack_public_path__ + "img/hutaomu6.e088024a.jpg";